import { z } from 'zod';
const IsoDate = z.string().date('valid YYYY-MM-DD date required');
// ---- Audit trail (compliance demo C10) --------------------------------------
/** Filters over `audit.events`; dates are calendar days in Sydney, Australia time, both ends included. */
export const AuditEventQuery = z.object({
    /** The record's id; with `related=true` also events whose `detail.caseId` is this id (a case's inspections, audits and actions). */
    entityId: z.string().trim().min(1).max(100).optional(),
    related: z
        .enum(['true', 'false'])
        .transform((v) => v === 'true')
        .optional(),
    /** Username or display name (partial, any case), or the actor id. */
    actor: z.string().trim().min(1).max(100).optional(),
    /** Action prefix, e.g. `compliance.case` for every case step. */
    action: z.string().trim().min(1).max(100).optional(),
    from: IsoDate.optional(),
    to: IsoDate.optional(),
    /** Events with an id below this (the previous page's `nextBefore`). */
    before: z.coerce.number().int().positive().optional(),
    limit: z.coerce.number().int().min(1).max(500).default(100),
});
export const AuditEvent = z.object({
    id: z.number().int(),
    occurredAt: z.string(),
    actorId: z.string().nullable(),
    actorType: z.enum(['user', 'service', 'anonymous']),
    actorUsername: z.string().nullable(),
    actorName: z.string().nullable(),
    action: z.string(),
    entityType: z.string().nullable(),
    entityId: z.string().nullable(),
    participantId: z.string().nullable(),
    participantName: z.string().nullable(),
    correlationId: z.string().nullable(),
    outcome: z.enum(['success', 'denied', 'failure']),
    detail: z.record(z.unknown()),
});
export const AuditEventList = z.object({
    items: z.array(AuditEvent),
    /** Pass as `before` for the next (older) page; null when this is the last. */
    nextBefore: z.number().int().nullable(),
});
export const AuditActionList = z.object({ items: z.array(z.string()) });
//# sourceMappingURL=audit.js.map